import { useContext } from "react";
import { ThemeContext } from "styled-components";
function useColorScheme(colorName) {
  const { color } = useContext(ThemeContext);
  switch (colorName) {
    case "black":
      return {
        backgroundColor: color.black10,
        borderColor: color.black10,
        textColor: "white"
      };
    case "blue":
      return {
        backgroundColor: color.blue1,
        borderColor: color.blue3,
        textColor: void 0
      };
    case "gray":
      return {
        backgroundColor: color.monochrome2,
        borderColor: color.monochrome4,
        textColor: void 0
      };
    case "green":
      return {
        backgroundColor: color.green1,
        borderColor: color.green3,
        textColor: void 0
      };
    case "red":
      return {
        backgroundColor: color.red1,
        borderColor: color.red3,
        textColor: void 0
      };
    case "white":
      return {
        backgroundColor: color.white10,
        borderColor: color.monochrome4,
        textColor: void 0
      };
    case "yellow":
      return {
        backgroundColor: color.yellow1,
        borderColor: color.yellow3,
        textColor: void 0
      };
  }
  return {
    backgroundColor: "transparent",
    borderColor: color.monochrome4,
    textColor: void 0
  };
}
export {
  useColorScheme
};
